import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { publicApi } from "../hooks/useApi";

export default function Search() {
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  useEffect(() => { setQ(params.get("q") || ""); }, [params]);
  const { data } = useQuery({ queryKey: ["search", q], queryFn: async () => (await publicApi.get(`/search?q=${encodeURIComponent(q)}`)).data, enabled: q.length > 1 });

  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="search-page">
      <h1 className="font-display text-display-sm mb-6">Search</h1>
      <input
        autoFocus
        data-testid="global-search-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search episodes, books, lessons, Gold…"
        className="bg-white/5 border border-white/15 px-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-white/40"
      />
      {data && (
        <div className="mt-10 space-y-8">
          {[["episodes", "/listen"], ["books", "/read"], ["audio", "/audio"], ["lessons", "/learn/lessons"]].map(([key, base]) => (
            data[key]?.length > 0 && (
              <div key={key}>
                <p className="text-xs uppercase tracking-wide text-white/70 mb-3">{key}</p>
                <ul className="space-y-2">
                  {data[key].map((item) => (
                    <li key={item.id}>
                      <Link to={`${base}/${item.id}`} data-testid={`search-result-${item.id}`} className="text-sm hover:text-brandAccent">{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            )
          ))}
          {data.gold?.length > 0 && (
            <div>
              <p className="text-xs uppercase tracking-wide text-white/70 mb-3">gold</p>
              <ul className="space-y-2">
                {data.gold.map((item) => (
                  <li key={item.id}>
                    <Link to="/gold" data-testid={`search-result-${item.id}`} className="text-sm hover:text-brandAccent">{item.title} <span className="text-white/60">— open in Gold Vault</span></Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
